// extracted by mini-css-extract-plugin
export default {"linkWrapper":"settings-index__linkWrapper--jdQ7A"};